<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-lg-6">
                    <competencies-crud :domains="domains"></competencies-crud>
                </div>
                <div class="col-lg-6">
                    <domains-crud @change="domains = $event"></domains-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CompetenciesCrud from './competencies/CompetenciesCrud';
    import DomainsCrud from './competencies/DomainsCrud';

    export default {

        components: {
            CompetenciesCrud, DomainsCrud
        },

        data() {
            return {
                domains: []
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.competencies'),
                    },
                ]
            }
        },
    }
</script>
